/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';

const Toggle = ({ name, leftText, leftUnit, leftVal, rightText, rightUnit, rightVal, setValue, className }) => {
    const [toggle, setToggle] = useState(false);
    const toggleStyle = className ? `toggle ${className}` : `toggle`;

    useEffect(() => {
        setValue(toggle === false ? leftVal : rightVal);
    }, [toggle, setValue, leftVal, rightVal]);

    return (
        <div className={toggleStyle}>
            <div className="toggle-name">
                <p>{leftText}</p>
                <p>{leftUnit}</p>
            </div>
            <input
                className="toggle-checkbox"
                type="checkbox"
                id={name}
                checked={toggle}
                onChange={() => {
                    setToggle(!toggle);
                }}
            />
            <label className="toggle-label" htmlFor={name} />
            <div className="toggle-name">
                <p>{rightText}</p>
                <p>{rightUnit}</p>
            </div>
        </div>
    );
};

export default Toggle;
